import { z } from "zod"
import { optionSchema } from "@/common/schemas/option.schema"

export const createSchema = z.object({
  active: z.boolean({ message: "O campo de status deve ser verdadeiro ou falso." }).default(true),
  option_id: optionSchema,
  parameters: z.record(z.string(), z.string()).superRefine((obj, ctx) => {
    Object.entries(obj).forEach(([key, value]) => {
      if (!value) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Campo ${key} é obrigatório`,
          path: [key],
        })
      }
    })
  })
});

export type TrackerIntegrationValidationSchema = z.infer<typeof createSchema>
